(function() {
    'use strict';

    // ReSharper disable once UndeclaredGlobalVariableUsing
    angular
        .module('app.service')
        .factory('utilitiesService', utilitiesService);

    // ReSharper disable once InconsistentNaming
    /* @ngInject */
    function utilitiesService() {
        var service = {
            getIndexOf: getIndexOf
        };

        return service;

        function getIndexOf(array, property, value) {
            var index = -1;
            array.some(function (entry, i) {
                if (entry[property] === value) {
                    index = i;
                    return true;
                }
                return false;
            });
            return index;
        }
    }

})();
